/**
 * @author Vaibhav Raut <vaibhav@wemotiveforge.com>
 */

import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Input, Layout, Alert, Typography } from 'antd';
import { ArrowRightOutlined, LockOutlined, MailFilled, MailOutlined, RedoOutlined, UserOutlined } from '@ant-design/icons';

import { signInRequest, addDeviceToAccount } from '../../AuthenticationApiActions';
import './SignIn.css';
import logo from '../../../../assets/logo.png';
import ConstantMessages from '../../../../utils/Strings';
import UtilHelper from "../../../../utils/UtilHelper";
import { ROUTE_ACTIONS, SYSTEM_ROLES } from '../../../../utils/Constants';
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";
import CustomFooter from "../../../Dashboard/components/CustomFooter/CustomFooter";
import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";
import { signIn } from "../../AuthenticationActions";
import Auth from "../../../../utils/Auth";
import DeviceChangeModal from "./DeviceChangeModal";
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'
// import { ReactComponent as LockClosedIcon } from "../../../../assets/icons/lock-closed.svg";
// import { ReactComponent as LineArrowRightIcon } from "../../../../assets/icons/line-arrow-right.svg";
// import { ReactComponent as MailIcon } from "../../../../assets/icons/mail.svg";
// import { ReactComponent as RetryIcon } from "../../../../assets/icons/retry.svg";

import appLogo from '../../../../assets/icons/genascreen-logo-white.png'
import appBackground from '../../../../assets/login-bg.png'

import '../../../../assets/css/predefined.css'

const { Header, Content } = Layout;
const FormItem = Form.Item;

/**
 * Login page shown to the user when session is not present
 */
class SignInForm extends React.Component {
  /**
   * This method is triggered when form is submitted by the user
   * @param e
   */
  handleSubmit = values => {
    // e.preventDefault();

    // this.props.form.validateFields((err, values) => {
      // if (!err) {
        this.setState({ showLoader: true, showError: false }, () => {
          this.props.onLogin(values).then(res => {
            if (res.loginActivityLog.hasOwnProperty('registeredDeviceLimitReached')) {
              this.setState({
                showLoader: false,
                showDeviceChangeModal: true,
                deviceChangeMessage: res.loginActivityLog.registeredDeviceLimitReachedMsg,
                loginResponse: res
              });
            } else if (res.loginActivityLog.hasOwnProperty('registeredDeviceChanged')) {
              this.setState({
                showLoader: false,
                showDeviceChangeModal: true,
                deviceChangeMessage: res.loginActivityLog.registeredDeviceChangedMsg,
                loginResponse: res
              });
            } else {
              this.signUserToSystem(res);
            }
          }, (error) => {
            this.setState({ showLoader: false }, () => {
              if (error.response && error.response.status === 401)
                
                if (error.response.data.error) {
                  this.setState({ showError: true, errorMessage: error.response.data.error })
                } else {
                  this.setState({ showError: true })
                }
                // this.showLoginError(error.response.data.error);
            });
          });
        });
      // }
    // });
  };

  signUserToSystem = res => {
    this.props.signInSuccess(res);
    let { user } = res;
    Auth.login(user);
  };

  constructor(props) {
    super(props);

    this.state = {
      showLoader: false,
      showError: false,
      errorMessage: 'Email or password does not match records. Please try again.',
      showDeviceChangeModal: false,
      deviceChangeMessage: '',
      loginResponse: {}
    }
  }

  /**
   * Render the UI of the login form
   * @returns {XML}
   */
  render() {
    document.title = 'GENA Screen';


    if (this.props.loggedInUser) {
      if (this.props.loggedInUser.isSystemGeneratedPassword) {
        return (<Redirect to="/forceResetPassword" />);
      }
      // else if (!this.props.loggedInUser.isSurveySubmitted) {
      //   return (<Redirect to="/survey" />);
      // } 
      else {
        const roles = this.props.loggedInUser.roles;
        if (roles[0].name === SYSTEM_ROLES.SUPER_ADMIN) {
          return (<Redirect to={ROUTE_ACTIONS.SETTINGS} />);
        } else {
          return (<Redirect to={ROUTE_ACTIONS.SEARCH} />);
        }
      }
    } else {
      return (
        <Layout className="login-layout">
          <Header className="login-layout-header">
            {/* Logo on the Left */}
            <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
            <Button className="btn" ghost={true} href="/contact-us">
              Contact
              <CustomIcon name="OpenFolder" />
              {/* <MailFilled /> */}
            </Button>
          </Header>
          <Content className='login-layout-content'>
            <div className='login-container' style={{ width: '400px', backgroundColor: '#FFFFFF' }}>
              <div className="login-container-header">
                <div className="flex-vertical-gap-1" style={{ alignItems: "center" }}>
                  <CustomIcon name="LockClosed" width={48} height={48} />
                  <Typography.Title style={{ margin: 0 }} level={2}>
                    Login
                  </Typography.Title>
                </div>
                <Form form={this.props.form} layout="vertical" style={{ width: '100%', padding: '0px', backgroundColor: 'transparent' }} onFinish={this.handleSubmit}>
                  <FormItem
                    name="username"
                    label="Email"
                    rules={[
                      { required: true, message: ConstantMessages.usernameRequired },
                      { validator: UtilHelper.validateBlankSpaces },
                    ]}
                  >
                    <Input prefix={<UserOutlined />} placeholder="Email" />
                  </FormItem>
                  <FormItem
                    name="password"
                    label="Password"
                    rules={[
                      { required: true, message: ConstantMessages.passwordRequired },
                      { validator: UtilHelper.validateBlankSpaces },
                    ]}
                  >
                    <Input.Password prefix={<LockOutlined />} type="password" placeholder="Password" iconRender={(visible) => (visible ? <CustomIcon name="ShowPass" color="#FFF"/> : <CustomIcon name="HidePass" color="#FFF"/>)}/>
                  </FormItem>
                  <FormItem>
                    <Button
                      className="margin-top-2"
                      block
                      type="primary"
                      htmlType="submit"
                    >
                      Login
                      <CustomIcon name="LineArrowRight"/>
                      {/* <ArrowRightOutlined /> */}
                    </Button>
                  </FormItem>
                  {
                    this.state.showError && (
                      <FormItem>
                        <Alert className="custom-alert-error" message={this.state.errorMessage} type="error" showIcon icon={<CustomIcon name="ErrorAlert" color="#FFFFFF" />} />
                      </FormItem>
                    )
                  }
                  <FormItem>
                    <div style={{ textAlign: 'center' }}>Don't have an account?&nbsp;<Button href="/signup" type="link" style={{ padding: 0 }}>Sign up</Button></div>
                  </FormItem>
                </Form>
              </div>
              <div className="login-container-footer">
                <Button className="btn" block href="/forgotPassword">
                  Reset Password
                  <CustomIcon name="Retry"/>
                  {/* <RedoOutlined /> */}
                </Button>
              </div>
            </div>

            <MessageModal ref="messageModal" />
            <DeviceChangeModal
              ref="deviceChange"
              showDeviceChangeModal={this.state.showDeviceChangeModal}
              deviceChangeMessage={this.state.deviceChangeMessage}
              addDeviceToAccount={this.addDeviceToAccount}
            />
          </Content>
          <GenaLoader showLoader={this.state.showLoader} />
        </Layout>
      );
    }
  }

  /**
   * Show modal with the message and title received from the server
   * @param loginErrorMessage
   * @param loginErrorTitle
   */
  // showLoginError(loginErrorMessage = 'User name or password is incorrect.', loginErrorTitle = "Invalid Credentials") {
  //   this.refs.messageModal.setState({
  //     showModal: true, message: loginErrorMessage, title: loginErrorTitle,
  //     showOkButton: true,
  //     handleOk: () => {
  //     },
  //     okText: 'Ok'
  //   });
  // }

  addDeviceToAccount = deviceName => {
    this.setState({ showLoader: true }, () => {
      const { loginActivityLog } = this.state.loginResponse;
      this.props.addDeviceToAccount(deviceName, loginActivityLog.id).then(res => {
        this.signUserToSystem(this.state.loginResponse);
      }, err => {
        this.setState({ showLoader: false });
      });
    });
  }
}

let SignIn = (props) => {
  const [form] = Form.useForm();
  return <SignInForm form={form} {...props} />;
};

const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser,
    signUp: state.auth.signUp
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onLogin: (data) => {
      return dispatch(signInRequest(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
    addDeviceToAccount: (deviceName, deviceId) => {
      return dispatch(addDeviceToAccount(deviceName, deviceId)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
    signInSuccess: data => {
      dispatch(signIn(data));
    }
  }
};

SignIn = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn);

export default SignIn;
